var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_426_100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4166 13.3952V15.7702C17.4175 15.9907 17.3724 16.209 17.284 16.411C17.1957 16.613 17.0662 16.7943 16.9037 16.9434C16.7412 17.0924 16.5494 17.2059 16.3406 17.2765C16.1317 17.3472 15.9104 17.3734 15.6908 17.3536C13.2547 17.0889 10.9147 16.2564 8.85872 14.9232C6.94591 13.7077 5.32419 12.086 4.10872 10.1732C2.77078 8.10786 1.93816 5.75644 1.6783 3.30941C1.65852 3.09048 1.68454 2.86984 1.7547 2.66153C1.82486 2.45321 1.93763 2.26179 2.08582 2.09944C2.23402 1.93709 2.4144 1.80738 2.61547 1.71857C2.81654 1.62975 3.0339 1.58378 3.25372 1.58357H5.62872C6.01292 1.57979 6.38539 1.71584 6.6767 1.96637C6.96801 2.2169 7.15828 2.5648 7.21205 2.94524C7.31229 3.70529 7.4982 4.45157 7.76622 5.16982C7.87273 5.45318 7.89578 5.76113 7.83264 6.05719C7.7695 6.35324 7.62282 6.62499 7.40997 6.84024L6.40455 7.84566C7.53153 9.82763 9.17258 11.4687 11.1546 12.5957L12.16 11.5902C12.3752 11.3774 12.647 11.2307 12.943 11.1676C13.2391 11.1044 13.547 11.1275 13.8304 11.234C14.5486 11.502 15.2949 11.6879 16.055 11.7882C16.4395 11.8424 16.7907 12.0361 17.0418 12.3324C17.2929 12.6287 17.4263 13.007 17.4166 13.3952Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_426_100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.74c3843a66ce101495620c38eb608891.svg";
export { ForwardRef as ReactComponent };